module.exports = __webpack_public_path__ + "img/ja.38747ccc.png";